import { CommonModule } from '@angular/common';
import { Component, inject, Input, input } from '@angular/core';
import { ImageModule, IMAGE_MAX_SIZES } from '@epicuro-next/ataraxia/image';
import { ProductPriceModule } from '@epicuro-next/ataraxia/product-price';
import { ProductIdPipe } from '@epicuro-next/ataraxia/product-title';
import { dynamicElementsHorizontalProductCard } from '@epicuro-next/constants/dynamic-elements';
import { DontTreeShake } from '@epicuro-next/elements/core';
import { DynamicComponentRegister } from '@epicuro-next/platform/dynamic-components-registrator';
import { withPcardSettingStoreFeature } from '@epicuro-next/state/p-basket-state';
import { signalStore } from '@ngrx/signals';
import { Product } from 'graphql-api/gql-api-interfaces';

// tslint:disable-next-line:variable-name
const PCardSettingStore = signalStore(withPcardSettingStoreFeature());
@DynamicComponentRegister(dynamicElementsHorizontalProductCard, true)
@Component({
  selector: 'atx-horizontal-product-card',
  imports: [CommonModule, ProductPriceModule, ImageModule, ProductIdPipe],
  templateUrl: './horizontal-product-card.component.html',
  styleUrl: './horizontal-product-card.component.scss',
  providers: [PCardSettingStore],
})
export class HorizontalProductCardComponent {
  private readonly pcardSettingsStore = inject(PCardSettingStore);

  @Input()
  public product!: Product;

  public imageMaxSize = input<number>(IMAGE_MAX_SIZES.AVATAR);

  public readonly showWspdPrice = this.pcardSettingsStore.showWspdPrice;
  public readonly showWholeSalePrices =
    this.pcardSettingsStore.showWholeSalePrices;
  public readonly showMarkupPrice = this.pcardSettingsStore.showMarkupPrice;
  public readonly productIdAdditionalPrefixRexExp =
    this.pcardSettingsStore.productIdAdditionalPrefixRexExp;
}

DontTreeShake(HorizontalProductCardComponent);
